import {Component, Inject, OnInit, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdxPaymentService} from 'src/app/adx-payment/service/adx-payment.service';

@Component({
    selector: 'adx-booking-link-payments-modal',
    templateUrl: './adx-booking-link-payments-modal.component.html',
    standalone: false
})
export class AdxBookingLinkPaymentsComponent implements OnInit {
  paymentsData?: any[];
  profileTypeId: number = 0;

  constructor(
    @Optional() public dialogRef: MatDialogRef<AdxBookingLinkPaymentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private paymentDetailService: AdxPaymentService,
  ) {
    if (typeof data === 'object' && data !== null) {
      this.profileTypeId = data.profileTypeId || 0;
    }
  }

  ngOnInit(): void {
    const bookingId = typeof this.data === 'number' ? this.data : this.data?.bookingId;

    if (bookingId) {
      this.paymentDetailService.getPaymentByBookingId(bookingId).subscribe((data) => {
        if (this.profileTypeId) {
          this.paymentsData = data.filter(payment => payment.profileTypeId === this.profileTypeId);
        } else {
          this.paymentsData = data;
        }
      });
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  getProfileTypeName(): string {
    return this.profileTypeId === 3 ? 'Client (Individual)' :
      this.profileTypeId === 5 ? 'Vendor' : 'All';
  }
}
